import { Box } from '@mui/material';

import { ComplianceTypes } from '@/constants';
import {
  EpisodeCard,
  EpisodeCardGutterSpacing,
  EpisodeCardVariants,
} from '@/containers/EpisodeCard';
import { bookmarkForLater, earnCpd, earnCpe } from '@/images';
import {
  ComplianceType,
  EpisodeCard as EpisodeCardType,
  Referrer,
} from '@/types';

export const DesktopEpisodes = ({
  compliance,
  episodes,
  isLoading,
  referrer,
}: {
  compliance: ComplianceType;
  episodes?: EpisodeCardType[];
  isLoading: boolean;
  referrer: Referrer;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: EpisodeCardGutterSpacing[EpisodeCardVariants.MEDIUM],
        justifyContent: 'center',
      }}>
      {compliance === ComplianceTypes.CPE ? (
        <Box
          component="img"
          src={earnCpe}
          alt="Earn CPE"
          sx={{ transform: 'translateY(-30px)' }}
        />
      ) : (
        <Box
          component="img"
          src={earnCpd}
          alt="Earn CPD"
          sx={{ transform: 'translateY(-30px)' }}
        />
      )}
      {episodes?.map((episode, index) => (
        <EpisodeCard
          key={episode.episodeId}
          variant={EpisodeCardVariants.MEDIUM}
          episode={episode}
          referrer={{
            ...referrer,
            position: index + 1,
          }}
          isLoading={isLoading}
        />
      ))}
      <Box
        component="img"
        src={bookmarkForLater}
        alt="Bookmark for later"
        sx={{ transform: 'translateY(30px)' }}
      />
    </Box>
  );
};
